import { AuthService } from './../../../services/auth.service';
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { EventEmitter } from "events";
import { DialogData } from "src/app/entities/dialogData";
import { UserStatus } from "src/app/entities/states/userStatus";
import { User } from "src/app/entities/user";
import { UserStatusName } from "src/app/entities/util";
import { DropdownService } from "src/app/services/dropdown.service";
import { SharedService } from "src/app/services/sharedService";
import { UserService } from "src/app/services/user.service";
import { DialogCommunicator } from "../dialog-communicator";
import { InformationDialogComponent } from "../information-dialog/information-dialog.component";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: "gov-user-dialog",
  templateUrl: "./user-dialog.component.html",
  styleUrls: ["./user-dialog.component.css"],
})
export class UserDialogComponent extends DialogCommunicator implements OnInit {
  text: string;
  emitter: EventEmitter;
  user: any;
  statusNames = UserStatusName;
  userStatus = UserStatus;
  branches = [];
  usernames = [];
  userroles = [
    "ADMIN",
    "MAYOR_TREASURER",
    "CENTRAL_READER",
    "FINANCIAL_MANAGER_ADMINISTRATOR",
    "FINANCIAL_EDITOR",
    "CENTRAL_EDITOR",
    "SECRETARY_ASSISTANT",
    "AGENT_RECENSEUR",
    "PROPERTIES_EDITOR",
    "PROPERTIES_LECTEUR",
    // "FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_EDITOR",
    "FINANCIAL_MANAGER_ADMINISTRATOR_AND_PROPERTIES_LECTEUR",
    "MAYOR_TREASURER_AND_PROPERTIES_LECTEUR",
    "INFO_API"
  ];
  repeatPassword = "";
  municipalities: any[];
  countryCode: any;
  subscriptionConfirm
  filterData
  constructor(
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public sharedService: SharedService,
    public userService: UserService,
    public confirmationDialog: MatDialog,
    public dropdownService: DropdownService,
    public authService: AuthService,
    public adminService: AdminService
  ) {
    super(dialogRef, sharedService);
    this.setConfirmationDialog(this.confirmationDialog);
  }

  async ngOnInit() {
    this.user = new User();
    this.countryCode = await this.adminService.getCountryCode().toPromise()
    
    if (this.data) {
      this.user = await this.userService.getResource("user", this.data["id"]).toPromise()
      this.user["class"] = "USER";
      this.setEntity(this.user);
    } else {
      this.user.status = UserStatus.ACTIVE;
      this.setEntity(this.user);
    }
    try {
      this.municipalities = await this.dropdownService.getList("municipality").toPromise()
    } catch (error) {
      console.log(error)
    }
    this.userService.getUsernames().subscribe(val => {
      this.usernames = val
        .map(user => user.username?.trim().toLowerCase())
        .filter(u => !!u);
  
      this.filterData.users = val
        .map(user => ({ id: user.username.trim(), name: user.username }))
        .sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value) return option === value;
    return false;
  };
  selectChange = (event: any) => {
    this.user["municipalities"] = event.data;
  };

  validNum = false
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.validNum = this.checkValidnumbers()
    },1000)
  }

  handleSelection(event) {
    setTimeout(() => {
      this.validNum = this.checkValidnumbers()
    },0)
  }

  checkValidnumbers(){
    if (!this.validNumbers) return true
    return Object.values(this.validNumbers).every(value => value === true);
  }
  validNumbers
  isValidPhone(key): boolean {
    if (!this.validNumbers) this.validNumbers = {};
    this.validNumbers[key] = false;
  
    if (!this.countryCode || !this.countryCode.code || !this.countryCode.numberFormat) {
      this.validNumbers[key] = true;
      return true;
    }
  
    const num = this.user.phone?.toString() || '';
    const regex = new RegExp(`^\\${this.countryCode.code}${this.countryCode.numberFormat}`);
  
    if (num) {
      this.validNumbers[key] = regex.test(num.toString());
      return this.validNumbers[key];
    }
  
    this.validNumbers[key] = true;
    return true;
  }

  needForMunicipalityByRole(role) {
    return !["ADMIN", "CENTRAL_READER", "CENTRAL_EDITOR"].includes(role);
  }

  async logOffUser(user) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: {
        text: "USER-DIALOG.CONFIRM_LOG_OFF",
        emitter: null,
        obj: { id: user.id }, action: "CONFIRM"
      }
    });
    
    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(async val => {
      if (val) {
        try {
          await this.authService.logoff(val['id']).toPromise();
          const infoDialogRef = this.dialog.open(InformationDialogComponent, {
            width: '500px',
            data: { text: 'USER-DIALOG.LOGGED_OFF_SUCCESSFULLY' }
          });
          infoDialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close(true); 
          });
        } catch (err) {
          console.error('Error logging off user', err);
          this.dialog.open(InformationDialogComponent, {
            width: '500px',
            data: { text: 'USER-DIALOG.LOGOUT_FAILED' }
          });
        }
      }
    })
  
    dialogRef.afterClosed().subscribe(() => {
      this.subscriptionConfirm.unsubscribe();
    });
  }
  
  async saveUser(id) {
    const normalizedUsername = (this.user.username || '').trim().toLowerCase();
    if (!id && normalizedUsername && this.usernames.includes(normalizedUsername)) {
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.USERNAME_ALREADY_EXISTS" }
      });
      return;
    }
    const existingByEmail = await this.userService.getUserByEmail(this.user.email).toPromise();
  
    let existingByPhone = null;
    if (this.user.phone && this.user.phone.trim() !== "") {
      existingByPhone = await this.userService.getUserByPhone(this.user.phone).toPromise();
    }
  
    let emailExists = existingByEmail && (!id || existingByEmail.id !== id);
    let phoneExists = existingByPhone && (!id || existingByPhone.id !== id);
  
    if (emailExists) {
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.EMAIL_ALREADY_EXISTS" },
      });
      return;
    }
    if (phoneExists) {
      this.dialog.open(InformationDialogComponent, {
        width: "500px",
        disableClose: true,
        data: { text: "DIALOG.PHONE_ALREADY_EXISTS" },
      });
      return;
    }
    this.onUpdateClick(id ? "UPDATE" : "SAVE", "UPDATE_USER");
  }  
}
